import React, { useEffect, useState } from "react";
import Banner from "../components/banner";
import { useNavigate, useParams } from "react-router-dom";
// import ContentJSON from "../content.json";
import Content from "../components/content";
import useAPI from "../hooks/use-api";

function Product() {
  const { productSlug } = useParams();
  const navigate = useNavigate();
  const api = useAPI();
  const [content, setContent] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const contentJSON = await api.getContent();
      setContent(contentJSON);
      setLoading(false);
    }
    fetchData();
  });

  if (isLoading) {
    return <h1 className="text-2xl p-5 text-center">Loading...</h1>;
  }

  return (
    <div>
      {content?.map((product) => {
        if (product.title === productSlug) {
          const handleGoToPurchase = () => {
            const activeKey = String(product?.title || '').trim()
            if (!activeKey) return
            navigate(`/purchase?active=${encodeURIComponent(activeKey)}`)
          }

          const handleGoToPurchaseKeyDown = event => {
            if (!event) return
            if (event.key !== 'Enter' && event.key !== ' ') return
            event.preventDefault()
            handleGoToPurchase()
          }

          return (
            <div key={product?.title}>
              <div className="relative w-full">
                <div className="hidden md:block w-full">
                  <Banner
                    src={require(`@/assets/img/desktop_banner_${productSlug}.jpg`).default}
                    // src={`https://weblink.shopeepay.co.th/img/seainsure/desktop_banner_${productSlug}.jpg`}
                    style={{ width: '100%' }}
                    loading="lazy"
                  />
                </div>

                <div className="md:hidden w-full">
                  <Banner
                    className="object-fit"
                    src={require(`@/assets/img/mobile_banner_${productSlug}.jpg`).default}
                    // src={`https://weblink.shopeepay.co.th/img/seainsure/mobile_banner_${productSlug}.jpg`}
                    style={{ width: '100%' }}
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="my-12 md:my-20">
                {product?.content.map((sub, index) => {
                  return <Content key={sub.title} data={sub} index={index} product={productSlug} />
                })}
              </div>

              {/* 点击跳转到purchase页 */}
              <div className="flex justify-center px-5 pb-10 md:pb-16">
                <button
                  type="button"
                  className="claim-button noSelect"
                  style={{ paddingLeft: '20px', paddingRight: '20px' }}
                  onClick={handleGoToPurchase}
                  onKeyDown={handleGoToPurchaseKeyDown}
                >
                  วิธีการซื้อประกัน
                </button>
              </div>
            </div>
          )
        } else {
          return <div className="hidden" key={product?.title} />;
        }
      })}
    </div>
  );
}

export default Product;
